export default __webpack_public_path__ + "static/media/ontario-fresh-profile-placeholder.1b59cba2.jpg";